import DashboardClickDrill from "../drill/DashboardClickDrill";

const ActionMode = {
  name: "actions",
  drills: [DashboardClickDrill],
};

export default ActionMode;
